// src/utils/indexedDB.js

import { openDB } from "idb";

const DB_NAME = "SportsDB";
const STORE_NAME = "sports";
const DB_VERSION = 1;

// ✅ Create DB
const dbPromise = openDB(DB_NAME, DB_VERSION, {
  upgrade(db) {
    if (!db.objectStoreNames.contains(STORE_NAME)) {
      db.createObjectStore(STORE_NAME);
    }
  },
});

// ✅ Save Data
export const setData = async (key, value) => {
  try {
    return (await dbPromise).put(STORE_NAME, value, key);
  } catch (err) {
    console.error("IndexedDB set error:", err);
  }
};

// ✅ Get Data
export const getData = async (key) => {
  try {
    return (await dbPromise).get(STORE_NAME, key);
  } catch (err) {
    console.error("IndexedDB get error:", err);
    return null;
  }
};

// ✅ Delete Data
export const deleteData = async (key) => {
  try {
    return (await dbPromise).delete(STORE_NAME, key);
  } catch (err) {
    console.error("IndexedDB delete error:", err);
  }
};

// ✅ Clear All
export const clearAllData = async () => {
  try {
    return (await dbPromise).clear(STORE_NAME);
  } catch (err) {
    console.error("IndexedDB clear error:", err);
  }
};